export default {
  id: 165,
  title: 'Target #165 - Pyramid',
  url: 'https://cssbattle.dev/play/165',
  colors: ['#F0CD48', '#66284A'],
  solution:
    '<a a><a b><a c><style>[b],body{background:#f0cd48}[a],[c]{height:100;background:#66284a}[b],[c]{clip-path:polygon(0 100%,50% 0,100% 100%)}a{position:fixed}[a]{top:30;left:150;width:100;border-radius:9in;color:#66284a;box-shadow:-100px 140px,100px 140px}[b]{top:80;left:100;width:200;height:140}[c]{top:105;left:130;width:140}</style>',
}
